// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"340":"e93256bc","849":"e93256bc"}[chunkId] + ".chunk.css";
};